import {
  DEFAULT_HOMEPAGE_RECOMMENDATIONS_NUM,
  DEFAULT_RECOMMENDED_PAGE_RECOMMENDATIONS_NUM,
  HOMEPAGE_RECOMMENDATIONS_ALLOWED_TO_REMOVE_NUM,
  HOMEPAGE_RECOMMENDATIONS_LOCAL_STORAGE_KEY_PREFIX,
  NSFW_LOCAL_STORAGE_KEY,
  RECOMMENDED_PAGE_RECOMMENDATIONS_ALLOWED_TO_REMOVE_NUM,
  RECOMMENDED_PAGE_RECOMMENDATIONS_LOCAL_STORAGE_KEY_PREFIX,
  SFW_LOCAL_STORAGE_KEY,
} from "@/constants/common";
import { IRecommendationValues } from "@/hooks/types";
import { typedLocalStorageService } from "@/utils/localStorageRe";
import { IRecommendationsConfig } from "@next-platform/client-common-core";

interface RemoveRecommendationParams extends Pick<
  IRecommendationsConfig,
  | "homepageRecommendationsFetchCount"
  | "homepageRecommendationsDislikedAllowedToRemoveCount"
  | "recommendationspageFetchCount"
  | "recommendationspageDislikedAllowedToRemoveCount"
> {
  characterId: string;
  nsfwToggle: boolean;
}

interface FilterAndUpdateStorageParams {
  storageKey: string;
  characterId: string;
  totalCount: number;
  allowedToRemove: number;
}

const filterAndUpdateStorage = ({ storageKey, characterId, totalCount, allowedToRemove }: FilterAndUpdateStorageParams): void => {
  const recommendations = JSON.parse((typedLocalStorageService.getItem(storageKey) as unknown as string) || "{}");
  if (!recommendations?.recomms) return;

  recommendations.recomms = recommendations.recomms.filter((recomm: IRecommendationValues) => recomm.id !== characterId);
  const requiredCount = totalCount - allowedToRemove;

  if (recommendations.recomms.length <= requiredCount) {
    typedLocalStorageService.removeItem(storageKey);
  } else {
    typedLocalStorageService.setItem(storageKey, JSON.stringify(recommendations));
  }
};

export const removeRecommendationFromLocalStorage = ({
  characterId,
  nsfwToggle,
  homepageRecommendationsFetchCount,
  homepageRecommendationsDislikedAllowedToRemoveCount,
  recommendationspageFetchCount,
  recommendationspageDislikedAllowedToRemoveCount,
}: RemoveRecommendationParams): void => {
  const nsfwKey = nsfwToggle ? NSFW_LOCAL_STORAGE_KEY : SFW_LOCAL_STORAGE_KEY;

  filterAndUpdateStorage({
    storageKey: `${HOMEPAGE_RECOMMENDATIONS_LOCAL_STORAGE_KEY_PREFIX}_${nsfwKey}`,
    characterId,
    totalCount: homepageRecommendationsFetchCount ?? DEFAULT_HOMEPAGE_RECOMMENDATIONS_NUM,
    allowedToRemove: homepageRecommendationsDislikedAllowedToRemoveCount ?? HOMEPAGE_RECOMMENDATIONS_ALLOWED_TO_REMOVE_NUM,
  });

  filterAndUpdateStorage({
    storageKey: `${RECOMMENDED_PAGE_RECOMMENDATIONS_LOCAL_STORAGE_KEY_PREFIX}_${nsfwKey}`,
    characterId,
    totalCount: recommendationspageFetchCount ?? DEFAULT_RECOMMENDED_PAGE_RECOMMENDATIONS_NUM,
    allowedToRemove: recommendationspageDislikedAllowedToRemoveCount ?? RECOMMENDED_PAGE_RECOMMENDATIONS_ALLOWED_TO_REMOVE_NUM,
  });
};
